import { Modal } from 'antd';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { version } from '../../../base/env';
import { API } from '../../../request/api';

const Update = ({ showUpdateModal, setShowUpdateModal }) => {
  const Login = useSelector((state) => state.Login);
  const [updateVersionText, setUpdateVersionText] = useState('');

  useEffect(() => {
    API.get
      .config('update_version_text')
      .then((response) => {
        if (response.data.update_version_text) {
          setUpdateVersionText(response.data.update_version_text);
        }
        return response;
      })
      .catch((error) => {
        // eslint-disable-next-line no-console
        console.error('Error : ', error);
      });
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    /**
     * when current version is different from scf version
     * update the app
     */
    if (Login.carfillo_version !== version && !showUpdateModal) {
      setShowUpdateModal(true);
    }
    // eslint-disable-next-line
  }, [showUpdateModal, Login.carfillo_version]);

  const Update2 = () => {
    const newCarfillo = { ...JSON.parse(localStorage.getItem('carfillo')) };
    localStorage.setItem(
      'carfillo',
      JSON.stringify({
        ...newCarfillo,
        Login: {
          ...Login,
          carfillo_version: version
        }
      })
    );
    window.location.reload(true);
  };

  return (
    <Modal
      bodyStyle={{
        padding: 15
      }}
      centered
      closable={false}
      footer={null}
      maskClosable={false}
      onCancel={() => setShowUpdateModal(false)}
      title=""
      visible={showUpdateModal}>
      <div className="update-modal">
        <h3>نسخه جدید</h3>
        <p>{`نسخه ${version}`}</p>
        <p>{updateVersionText}</p>
        <div className="text-center mar-t-15 update-button-container">
          <button
            className="button flex-i center-content btn-h48 btn btn-red btn-300 line-none btn-round"
            onClick={Update2}
            type="button">
            بروزرسانی
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default Update;
